import { render, staticRenderFns } from "./EditClientDialog.vue?vue&type=template&id=042fa238&scoped=true&"
import script from "./EditClientDialog.vue?vue&type=script&lang=js&"
export * from "./EditClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditClientDialog.vue?vue&type=style&index=0&id=042fa238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042fa238",
  null
  
)

export default component.exports